export const TOKEN_UPDATION_SUCCESS = 'TOKEN_UPDATION_SUCCESS';
export const TOKEN_UPDATION_ERROR = 'TOKEN_UPDATION_ERROR';
export const TOKEN_ALREADY_EXISTS = 'TOKEN_ALREADY_EXISTS';
